import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Input, Button, Header, Icon } from "semantic-ui-react";

import { setPartyName } from "./hostActionCreators";
import { validatePartyName } from "../../../utils/utils";

class PartyNameForm extends Component {
  constructor(props) {
    super(props);
    this.state = { isEditing: false, partyNameInput: "" };
    this.handleSetName = this.handleSetName.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleClickEdit = this.handleClickEdit.bind(this);
  }

  handleSetName(event) {
    event.preventDefault();
    if (this.state.partyNameInput && this.state.partyNameInput.length > 0) {
      this.props.setPartyName(this.state.partyNameInput);
      this.setState({ isEditing: false });
    }
  }
  handleInputChange(event) {
    const trimmedPartyName = event.target.value.trim();
    if (validatePartyName(trimmedPartyName)) {
      this.setState({ partyNameInput: trimmedPartyName });
    } else if (trimmedPartyName.length === 0) {
      this.setState({ partyNameInput: trimmedPartyName });
    }
  }
  handleClickEdit = (event) => {
    this.setState({ isEditing: true });
  };

  render() {
    if (this.state.isEditing) {
      return (
        <div>
          <form onSubmit={this.handleSetName}>
            <Input
              inverted
              transparent
              fluid
              autoFocus
              placeholder={
                this.props.partyName
                  ? this.props.partyName
                  : "what's your party name?"
              }
              onChange={this.handleInputChange}
              value={this.state.partyNameInput}
              action={
                <Button inverted onClick={this.handleSetName}>
                  OK
                </Button>
              }
            />
          </form>
        </div>
      );
    } else {
      return (
        <div className="space-between-horizontal-container">
          <Header inverted as="h2" onClick={this.handleClickEdit}>
            <Header.Content>{this.props.partyName}</Header.Content>
            <Header.Subheader>Party by you</Header.Subheader>
          </Header>
          <Icon name="edit" size="large" onClick={this.handleClickEdit} />
        </div>
      );
    }
  }
}

PartyNameForm.propTypes = {
  setPartyName: PropTypes.func.isRequired,
  partyName: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => {
  return {
    partyName: state.party.partyName,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPartyName: (partyName) => dispatch(setPartyName(partyName)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PartyNameForm);
